














































































































import NewDocumentDialog from "@/components/NewDocumentDialog.vue";
import { deleteDocument, getDocuments, updateDocumentOrder } from "@/services";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Document } from "@/interfaces";
import draggable from "vuedraggable";

import { date } from "quasar";
import { notifyError, notifySuccess } from "@/common/notify";

@Component({
  components: {
    draggable,
  },
})
export default class DocumentsAreaManagement extends Vue {
  loading = false;
  editable = true;
  isDragging = false;
  delayedDragging = false;

  list: Document[] = [];

  async mounted() {
    try {
      this.loading = true;
      await this.loadData();
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  orderList() {
    this.list = this.list.sort((one: Document, two: Document) => {
      if (one.order !== undefined && two.order !== undefined) {
        return one.order - two.order;
      }

      return 0;
    });
  }

  onMove(data: any) {
    const relatedElement = data.relatedContext.element;
    const draggedElement = data.draggedContext.element;
    return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
  }

  openAddDialog() {
    this.$q
      .dialog({
        component: NewDocumentDialog,
        parent: this,
        title: "Aggiungi Documento",
      })
      .onOk(() => {
        this.loadData();
      });
  }

  openEditDialog(document: Document) {
    this.$q
      .dialog({
        component: NewDocumentDialog,
        parent: this,
        title: "Modifica Documento",
        document,
      })
      .onOk(() => {
        this.loadData();
      });
  }

  onDelete(element: Document) {
    this.$q
      .dialog({
        title: "Attenzione",
        message: "Sei sicuro di volere eliminare il documento?",
        html: true,
        cancel: true,
      })
      .onOk(() => {
        this.deleteDocumentElement(element);
      });
  }

  async loadData() {
    try {
      const documents = await getDocuments();
      this.list = documents.map((document, index) => ({
        ...document,
        order: index,
        fixed: false,
      }));
    } catch (error) {
      console.log(error);
      notifyError("Errore imprevisto, non è stato possibile caricare i documenti!");
    }
  }

  async deleteDocumentElement(element: Document) {
    try {
      await deleteDocument(element.id);
      await this.loadData();
      notifySuccess("Documento rimosso con successo!");
    } catch (error) {
      console.log(error);
      notifyError("Errore imprevisto, non è stato possibile eliminare il documento!");
    }
  }

  async onListDragEnd() {
    this.isDragging = false;
    try {
      await updateDocumentOrder(this.list);
    } catch (error) {
      console.log(error);
    }
  }

  getDate(element: Document) {
    return date.formatDate(element.updated_at, "DD/MM/YYYY HH:mm");
  }

  get dragOptions() {
    return {
      animation: 0,
      group: "description",
      disabled: !this.editable,
      ghostClass: "ghost",
    };
  }

  @Watch("isDragging")
  onIsDragging(newValue: any) {
    if (newValue) {
      this.delayedDragging = true;
      return;
    }
    this.$nextTick(() => {
      this.delayedDragging = false;
    });
  }
}
